export const SIGNATURE_TYPE = {
  GUEST: 'Guest',
  VOLUNTEER: 'Volunteer'
};
